import React from 'react';
import { TableCell, TableCellProps, makeStyles } from '@material-ui/core';

type TableHeaderCellProps = TableCellProps & {};

export function TableHeaderCell (props: TableHeaderCellProps) {
    const cls = useStyles();

    return (
        <TableCell className={cls.root} {...props} />
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        fontWeight: 'bold'        
    }
}))